import omit from "lodash/omit";
import { SignupPersistedDataType } from "../../../../components/Auth/Signup/SignupFormSchema";
import { executeNetworkAsync } from "../../../helper/handler/network";
import { clientAxiosInstance } from "../../../types/swrFetcher";

export const authGetOtpController = async (
  email: string,
  action: string,
  recaptchaToken: string,
  country: string,
  signupData?: SignupPersistedDataType
) => {
  const networkCall = async () =>
    await clientAxiosInstance().post("/api/auth/otp/get", {
      email,
      action,
      country,
      recaptchaToken,
      signupData:
        action === "signup"
          ? JSON.stringify(omit(signupData, ["token"]))
          : "",
    });

  const [result, error] = await executeNetworkAsync(networkCall);
  return [result, error];
};
